const Config = require('~config/default.env').default;
import axios from 'axios';

const getPosStore = async (params) => {
  return await axios.get(`${Config.MS_POS_API_URL}/stores`, { params });
};

export { getPosStore };
